export default __webpack_public_path__ + "static/media/card.e28beb9f.svg";